import classNames from 'classnames';
import type { FC } from 'react';

import { SeniorityLevelEnum } from '@/services/externalCandidates';
import { capitalizeFirstLetter } from '@/utils/cvGenerator';

import Chip from '../Chip';

type Props = {
  seniority?: string | null;
};

const SeniorityChip: FC<Props> = ({ seniority }) => {
  if (!seniority) return null;
  return (
    <Chip
      variant="unstyled"
      size="sm"
      className={classNames('w-fit !py-0.5', {
        'bg-neutral-700': seniority === SeniorityLevelEnum.INTERN,
        'bg-successDark/90': seniority === SeniorityLevelEnum.JUNIOR,
        'bg-secondary-500/70': seniority === SeniorityLevelEnum.MID,
        'bg-jb-alert-400/70': seniority === SeniorityLevelEnum.SENIOR,
        'bg-jb-secondary-500/80': seniority === SeniorityLevelEnum.LEAD,
      })}
    >
      {capitalizeFirstLetter(seniority)}
    </Chip>
  );
};

export default SeniorityChip;
